import {useMutation, useQueryClient} from '@tanstack/react-query';

import {invalidateAllTrustAccountTeams} from '@/features/trust-accounts/utils/trust-account-invalidations.utils';
import {useApiClient} from '@/hooks';

import {teamApi} from '../api';
import {teamKeys} from './useTeamMembersQuery';

export function useRemoveMemberMutation() {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (memberId: string) => teamApi.removeMember(client, memberId),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: teamKeys.members()});
      queryClient.invalidateQueries({queryKey: teamKeys.roles()});
      invalidateAllTrustAccountTeams(queryClient);
    }
  });
}
